<template>
  <div class="we-chat-mini">
    <div class="swipe-content">
      <van-swipe
        class="my-swipe"
        :autoplay="3000"
        indicator-color="white"
        style="height: 200px"
        lazy-render
      >
        <van-swipe-item v-for="image in images" :key="image">
          <van-image fit="cover" :src="image" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="org-content" v-if="state.isLogin">
      <van-dropdown-menu>
        <van-dropdown-item @change="handleOrgChange" v-model="state.currentOrg" :options="state.orgList" />
      </van-dropdown-menu>

      <van-checkbox @click="handleOnlyIndividuals" style="margin-left: 24px" v-model="state.onlyIndividuals">仅看个人数据</van-checkbox>
    </div>
    
    <div class="content-row">
      <div class="content-title" @click="handleGoDetail">
          学校经营数据
          <van-icon name="arrow" />
      </div>
      <div class="report-content">
      <div class="report-total-container">
        <div class="report-total" @click="handleYongClick(ModuleType.College)">
          <span class="title-label">学校学生</span>
          <span v-if="state.isLogin" class="title-value">{{
            state.overview.stuNo ?? 0
          }}</span>
          <span v-else class="title-value">--</span>
        </div>
        <div
          class="report-total"
          @click="handleYongClick(ModuleType.InCourtyard)"
        >
          <span class="title-label">入住学生</span>
          <span
            v-if="state.isLogin"
            class="title-value"
            style="color: #91cc75"
            >{{ state.overview.checkInNo ?? 0 }}</span
          >
          <span v-else class="title-value" style="color: #91cc75">--</span>
        </div>

        <div class="report-total" @click="handleYongClick(ModuleType.Due)">
          <span class="title-label">即将到期</span>
          <span v-if="state.isLogin" class="title-value" style="color: red">{{
            state.overview.stuEndNo ?? 0
          }}</span>
          <span v-else class="title-value" style="color: red">--</span>
        </div>
      </div>
    </div>
    </div>
    

    <div class="content-row" v-for="(item, index) in state.statistics" :key="index">
      <div class="content-title" @click="handleGoDetail">
          {{ item.timeDesc }}
        </div>
      <div class="report-content">
        <div class="report-total-container">
          <div
            class="report-total"
            @click="handleChuClick(ModeType.ReturnHospital,item)"
          >
            <span v-if="state.isLogin" class="title-value"
              >{{ item.actualArrival ?? 0 }}/{{
                item.expectedArrival ?? 0
              }}</span
            >
            <span v-else class="title-value">--</span>
            <span class="title-label title-label-bottom">回院</span>
          </div>
          <div class="report-total" @click="handleChuClick(ModeType.Lunch,item)">
            <span v-if="state.isLogin" class="title-value"
              >{{ item.actualLunch ?? 0 }}/{{ item.expectedLunch ?? 0 }}</span
            >
            <span v-else class="title-value">--</span>
            <span class="title-label title-label-bottom" v-if="item.time === 2">午餐</span>
            <span class="title-label title-label-bottom" v-if="item.time === 3">晚餐</span>
          </div>

          <div class="report-total" @click="handleChuClick(ModeType.NoonBreak,item)" v-if="item.time === 2">
            <span v-if="state.isLogin" class="title-value"
              >{{ item.actualNap ?? 0 }}/{{ item.expectedNap ?? 0 }}</span
            >
            <span v-else class="title-value">--</span>
            <span class="title-label title-label-bottom">午休</span>
          </div>

          <div
            class="report-total"
            @click="handleChuClick(ModeType.LeavingHospital,item)"
          >
            <span v-if="state.isLogin" class="title-value"
              >{{ item.actualDeparture ?? 0 }}/{{
                item.expectedDeparture ?? 0
              }}</span
            >
            <span v-else class="title-value">--</span>
            <span class="title-label title-label-bottom">离院</span>
          </div>
        </div>
      </div>
    </div>
    <div class="login-container" v-if="state.isLogin">
        <!-- <van-cell title="退出登录" @click="handleGoLogin" is-link /> -->
        <van-button size="small" @click="handleGoLoginOut" plain type="primary" style="width: 120px">退出登录</van-button>
    </div>
  </div>
</template>
<script>
import { defineComponent, onMounted, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";

import EmptyData from "@/components/EmptyData.vue";
import HomeBackImg from "@/assets/home_back.jpg";
import HomeBackImg_1 from "@/assets/home_back_1.jpg";
import HomeBackImg_2 from "@/assets/home_back_2.jpg";

import { ModuleType, ModeType } from "@/utils/const";

import { queryGetDataForNoon, queryGetDataSummary, logOutSystem, querySelectOrgListByUser } from "@/api/user";
import dayjs from "dayjs";
import { showConfirmDialog, showNotify } from "vant";

export default defineComponent({
  components: {
    EmptyData,
  },
  setup() {
    const images = [HomeBackImg_1, HomeBackImg, HomeBackImg_2];
    const router = useRouter();
    const route = useRoute();

    const state = reactive({
      isLogin: false,
      statistics: [
        {
          actualArrival: null,
          actualDeparture: null,
          actualLunch: null,
          actualNap: null,
          expectedArrival: null,
          expectedDeparture: null,
          expectedLunch: null,
          expectedNap: null,
          time: 2,
          timeDes: '中午段'
        },
      ],
      currentOrg: null,
      onlyIndividuals: 0,
      orgList: [],
      overview: {},
    });

    onMounted(async () => {
      console.log("pathParams:", route?.query);
      if (route?.query?.page) {
        router.push({
          path: `${route?.query?.page}`,
          query: {
            id: route?.query?.id,
          },
        });
      } else if (route?.query?.token && route?.query?.userInfo) {
        localStorage.setItem('userInfo', route?.query?.userInfo);
        localStorage.setItem('token', route?.query?.token);
      }
      
      querySysOrgListByUser();
    });

    const handleOrgChange = (value) => {
      console.log('value>>>>>>>', value);
      state.currentOrg = value
      localStorage.setItem('currentOrg', state.currentOrg)
      queryGetDataForNoonData();
      queryGetDataSummaryData();
    }

    const querySysOrgListByUser = async () => {
      state.orgList = [];
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') ?? '{}');
        console.log('userInfo>>>>>>',userInfo)
        const result = await querySelectOrgListByUser({
          id: userInfo?.id,
        });
        console.log("result:", result);
        if (result.code === "00") {
          state.orgList = result.data.map(item => {
            return {
              ...item,
              text: item.name,
              value: item.id
            }
          }) ?? [];

          if(localStorage.getItem('currentOrg')) {
            state.currentOrg = Number(localStorage.getItem('currentOrg'))
            state.onlyIndividuals = Number(localStorage.getItem('onlyIndividuals'))
          } else {
            state.currentOrg = state.orgList[0].value
            localStorage.setItem('currentOrg', state.currentOrg)
            
          }

          queryGetDataForNoonData();
          queryGetDataSummaryData();
          
        }
      } catch (error) {
        state.orgList = []
      }
    }

    const queryGetDataSummaryData = async () => {
      console.log(localStorage.getItem("userInfo"))
      if (!localStorage.getItem("token") || !localStorage.getItem("userInfo")) {
        state.isLogin = false;
        return;
      }
      try {
        const result = await queryGetDataSummary({
          permissionOrg: state.currentOrg,
          oneSelf: state.onlyIndividuals ? 1 : 0
        });
        console.log("result:", result);
        if (result.code === "00") {
          state.overview = result.data ?? {};
          state.isLogin = true;
        } else if (result.code === "02") {
          state.isLogin = false;
        } else {
        }
      } catch (error) {
        console.log("error:>>>", error);
      }
    };

    const queryGetDataForNoonData = async () => {
      if (!localStorage.getItem("token") || !localStorage.getItem("userInfo")) {
        state.isLogin = false;
        return;
      }

      try {
        const result = await queryGetDataForNoon({
          day: dayjs().format("YYYY-MM-DD"),
          permissionOrg: state.currentOrg,
          oneSelf: state.onlyIndividuals ? 1 : 0
        });
        console.log("result:", result);
        if (result.code === "00") {
          state.statistics = result.data ?? [
            {
              actualArrival: null,
              actualDeparture: null,
              actualLunch: null,
              actualNap: null,
              expectedArrival: null,
              expectedDeparture: null,
              expectedLunch: null,
              expectedNap: null,
              time: 2,
              timeDes: '中午段'
            },
          ];
          state.isLogin = true;
        } else if (result.code === "02") {
          state.isLogin = false;
        } else {
        }
      } catch (error) {
        console.log("error:>>>", error);
      }
    };

    const handleGoLogin = () => {
      router.push({
        path: "/login",
      });
    };

    const handleGoLoginOut = () => {
      showConfirmDialog({
        title: "温馨提示",
        message: "您确定要退出登录吗？",
      })
        .then(async () => {
          // on confirm
          const _user = localStorage.getItem("userInfo");
          const userInfo = JSON.parse(_user ?? "{}");
          const result = await logOutSystem({
            id: userInfo.id
          })
          if(result.code === '00') {
            localStorage.removeItem("userInfo");
            localStorage.removeItem("token")
            showNotify({ type: 'success', message: '退出登录成功' , duration: 2000 })
            state.isLogin = false;
          } else {
            showNotify({ type: 'warning', message: result.message, duration: 2000 })
          }
          
        })
        .catch((e) => {
          // on cancel
          console.log("取消登录",e);
        });
    }

    const handleYongClick = (moduleType) => {
      if (!isLoginDialog()) {
        return;
      }
      router.push({
        path: "/collegeStudents",
        query: {
          moduleType,
          oneSelf: state.onlyIndividuals ? 1 : 0,
          permissionOrg: state.currentOrg
        },
      });
    };

    const handleChuClick = (moduleType,item) => {
      if (!isLoginDialog()) {
        return;
      }
      router.push({
        path: "/monitorStudents",
        query: {
          moduleType,
          timeType: item.time,
          oneSelf: state.onlyIndividuals ? 1 : 0,
          permissionOrg: state.currentOrg
        },
      });
    };

    const isLoginDialog = () => {
      if (state.isLogin) {
        return true;
      }
      showConfirmDialog({
        title: "温馨提示",
        message: "当前操作需要登录，请前往登录。",
      })
        .then(() => {
          // on confirm
          console.log("确认登录");
          handleGoLogin();
        })
        .catch(() => {
          // on cancel
          console.log("取消登录");
        });
    };

    const handleGoDetail = () => {
      if (!isLoginDialog()) {
        return;
      }  

      router.push({
        path: "/managementPanel",
        query: {
          currentOrg: state.currentOrg
        },
      });
    }

    const handleOnlyIndividuals = (value) => {      
      localStorage.setItem('onlyIndividuals',state.onlyIndividuals ? 1 : 0)
      queryGetDataForNoonData();
      queryGetDataSummaryData();
    }

    return {
      state,
      handleGoLogin,
      images,
      handleYongClick,
      ModuleType,
      handleChuClick,
      ModeType,
      handleGoLoginOut,
      handleOrgChange,
      handleGoDetail,
      handleOnlyIndividuals
    };
  },
});
</script>

<style scoped>
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 200px;
  text-align: center;
}

.we-chat-mini {
  background: #e9f1f8;
  height: 100vh;
  width: 100%;
  overflow-y: scroll;
  padding-bottom: 22px;
  z-index: 100;
  margin-top: 4px;
  position: relative;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.swipe-content {
  margin-left: 6px;
  margin-right: 6px;
}

.org-content {
  margin: 6px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

/deep/ .van-dropdown-menu__bar {
  background: none !important;
  box-shadow: none !important;
}

.report-content {
  /* margin: 12px 6px; */
  /* padding-top: 14px; */
  /* width: calc(100% - 12px); */
  background-color: #fff;
  border-radius: 7px;
  display: flex;
  height: 124px;
}

.content-row {
  background-color: #fff;
  border-radius: 7px;
  width: calc(100% - 12px);
  margin: 12px 6px;
  padding-top: 4px;
}

.report-total-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
}

.report-total {
  display: flex;
  flex-direction: column;
}

.title-label {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 17px;
  color: #000000;
}

.title-value {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 20px;
  color: #fac858;
  margin-top: 12px;
}

.title-label-bottom {
  margin-top: 12px;
}

.login-container {
  text-align: center;
  width: 100vw;
  bottom: 40px;
  margin-top: 22px;
}

.content-title {
  text-align: left;
    margin-left: 12px;
    margin-top: 12px;
    margin-right: 12px;
    width: calc(100% - 24px);
    display: flex;
    align-items: center;
    font-weight: bold;
    justify-content: space-between;
}
</style>
